
export default function useXAxisData () {
    const days = ['Mon', 'Tue', 'Wed', 'Thr', 'Fri', 'Sat', 'Sun']
    const createDays = () => days
    const __getMonthShortString = (num) => {
        switch (num) {
        case 1:
            return 'Jan'
        case 2:
            return 'Feb'
        case 3:
            return 'Mar'
        case 4:
            return 'Apr'
        case 5:
            return 'May'
        case 6:
            return 'Jun'
        case 7:
            return 'Jul'
        case 8:
            return 'Aug'
        case 9:
            return 'Sep'
        case 10:
            return 'Oct'
        case 11:
            return 'Nov'
        case 12:
            return 'Dec'
        }
    }
    const createLast12Months = (selectedMonth) => {
        const monthArr = selectedMonth.split('-')
        let year = monthArr[0]
        let month = parseInt(monthArr[1])
        const results = new Array(12).fill(null)
        for (let i = 0; i < 12; i++) {
            if (month === 0) {
                month = 12
                year--
            }
            results[i] = `${year}-${month < 10 ? '0' + month : month}`
            month--
        }
        return results.reverse()
    }

    const createThisMonthFullDate = (selectedMonth) => {
        const selectedMonthArray = selectedMonth.split('-')
        const year = selectedMonthArray[0]
        const month = selectedMonthArray[1]
        const lasyDay = new Date(year, month, 0).getDate()
        const fullDates = []
        for (let i = 0; i < lasyDay; i++) {
            const day = i + 1
            fullDates.push(day < 10 ? `0${day}` : day.toString())
        }
        return fullDates
    }

    return {
        __getMonthShortString,
        createDays,
        createLast12Months,
        createThisMonthFullDate
    }
}
